// Backend Configuration - Main backend for authentication and data
export const BACKEND_CONFIG = {
  // Primary backend URL - ALWAYS use production backend
  PRIMARY_URL: 'https://rtl-market.modernmoneyexperts.com',
  
  // API endpoints
  API_ENDPOINTS: {
    // Data endpoints
    DATA_RAW: '/api/data',
    DATA_CALCULATED: '/api/data-calculated',
    DATA_ACCUMULATED: '/api/accumulated-data',
    SUMMARY: '/api/summary',
    UPLOAD: '/api/upload',
    
    // Authentication endpoints
    LOGIN: '/api/auth/login',
    VERIFY: '/api/auth/verify',
    VERIFY_URL: '/api/auth/verify-url',
    VERIFY_FLEXIBLE: '/api/auth/verify-flexible',
    LOGOUT: '/api/auth/logout',
    SESSIONS: '/api/auth/sessions',
    
    // Analysis endpoints
    GAMMA_SHIFT: '/api/gamma-shift',
    GAMMA_SHIFT_STATS: '/api/gamma-shift/stats',
    GAMMA_SHIFT_EXPORT: '/api/gamma-shift/export-daily',
    
    // System endpoints
    HEALTH: '/health',
    TEST_API: '/test-api'
  },
  
  // WebSocket configuration
  WEBSOCKET: {
    URL: 'https://rtl-market.modernmoneyexperts.com',
    TRANSPORTS: ['websocket', 'polling'],
    TIMEOUT: 5000,
    RECONNECTION: true,
    MAX_RECONNECT_ATTEMPTS: 5,
    RECONNECT_DELAY: 1000
  },
  
  // Authentication configuration
  AUTH: {
    TOKEN_STORAGE_KEY: 'authToken',
    DEMO_TOKEN: 'demo-token',
    TOKEN_REFRESH_INTERVAL: 300000 // 5 minutes
  }
};

// Helper function to get full API URL
export const getBackendUrl = (endpoint: string): string => {
  return `${BACKEND_CONFIG.PRIMARY_URL}${endpoint}`;
};

// Helper function to get WebSocket URL
export const getWebSocketUrl = (): string => {
  return BACKEND_CONFIG.WEBSOCKET.URL;
};

// Configuration validation
export const validateBackendConfig = (): boolean => {
  const isValid = BACKEND_CONFIG.PRIMARY_URL.includes('rtl-market.modernmoneyexperts.com');
  
  if (!isValid) {
    console.error('❌ [BACKEND] Invalid backend configuration detected!');
    console.error('Expected: rtl-market.modernmoneyexperts.com');
    console.error('Actual:', BACKEND_CONFIG.PRIMARY_URL);
  } else {
    console.log('✅ [BACKEND] Configuration validated successfully');
    console.log('PRIMARY_URL (site/marketing):', BACKEND_CONFIG.PRIMARY_URL);
    console.log(
      'ℹ️ [INFO] API base is resolved in api.ts (same-origin /api when env URL is unset in browser).'
    );
  }
  
  return isValid;
};

// Export default configuration
export default BACKEND_CONFIG;
